<template>
  <div class="liu" v-wechat-title="'人工审核'">
    <div>
      <!-- 身份证信息 -->
      <div class="color-f-bg">
        <!-- 提示信息 -->
        <div class="say-color page-padding-l-r padding-t-10 padding-b-10 title-5">
          请拍摄本人的身份证证件
        </div>
        <!-- 身份证照片信息 -->
        <div class="flex say-color title-5">
          <!-- 人像面 -->
          <div class="flex-1 align-center">
            <div @click="cameraImgClick('renXiang')">
              <img :src="renXiang.webUrl" class="idCardStyle" v-if="renXiangImgShow" />
              <svg-icon v-else icon-class="authenticate-headshot" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <!-- 国徽面 -->
          <div class="flex-1 align-center">
            <div @click="cameraImgClick('guoHui')">
              <img :src="guoHui.webUrl" class="idCardStyle" v-if="guoHuiImgShow" />
              <svg-icon v-else icon-class="authenticate-emblem" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
      </div>
      <!-- 手持身份证信息 -->
      <div class="page-padding-l-r padding-t-10 padding-b-10 margin-t-10 flex color-f-bg">
        <div style="width: 105px">
          <div class="margin-r-10">手持身份证正面照</div>
        </div>
        <div class="flex-1" @click="cameraImgClick('shouChi')">
          <img :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" class="faceStyle" />
        </div>
      </div>
      <!-- 手持身份证信息提示 -->
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
        避免证件与头部重叠，身份证正反面内容要清晰可见，完全露出双手手臂；上传高分辨率图片可能需要一些时间请耐心等待
      </div>
      <!-- 提交按钮 -->
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large"
          :disabled="renXiangImgShow && guoHuiImgShow && shouChiImgShow ? false : true"
          @click="submitData">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import { SubmitAuditAndUserImage } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'ManualAudit',
  components: { SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份信息
      // formData: {
      //   idCardName: '',
      //   idCardNum: '',
      // },
      idCardName: '',
      renXiangImgShow: false,
      guoHuiImgShow: false,
      shouChiImgShow: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.idCardName = this.$route.query.idCardName;
      const imgType = this.$route.query.imgType;
      if (imgType) {
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxWebUrl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghWebUrl).replace('|', '?');
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scWebUrl).replace('|', '?');
        this.renXiangImgShow = this.renXiang.webUrl ? true : false;
        this.guoHuiImgShow = this.guoHui.webUrl ? true : false;
        this.shouChiImgShow = this.shouChi.webUrl ? true : false;
      };
    });
  },
  methods: {
    cameraImgClick(imgTypeStr) {
      const data = {
        page: 'media',
        h5Page: 'ManualAudit',
        imgType: imgTypeStr,
        idCardName: this.idCardName,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        scWebUrl: encodeURIComponent(this.shouChi.webUrl.replace('?', '|'))
      }
      wx.miniProgram.postMessage({ data });
      wx.miniProgram.redirectTo({
        url: '/pages/media/media',
      });
    },
    // 提交数据
    submitData() {
      CusLoadingOpen();
      SubmitAuditAndUserImage({
        idCardFrontUrl: this.renXiang.webUrl,
        idCardBackUrl: this.guoHui.webUrl,
        holdIdCardUrl: this.shouChi.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            CusAlert('已为您申请人工审核，预计将在1个工作日内完成审核', () => {
              wx.miniProgram.redirectTo({
                url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.idCardName}&flowName=认证流程`,
              });
            });
          } else {
            CusAlert(res.msg);
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
  }
};
</script>
